export const ENVIRONMENT = buildHttpEndpoint('/status/environment');
export const FORGOT_PIN = buildHttpEndpoint('/forgotPIN');
export const LOGIN = buildHttpEndpoint('/login');
export const LOGOUT  = buildHttpEndpoint('/logout');
export const DOB_VERIFY = buildHttpEndpoint('/verifyDOB');
export const NAME_VERIFY = buildHttpEndpoint('/verifyName');
export const CONVERSATION_DETAILS_GET = buildHttpEndpoint('/details');
export const CONVERSATION_DETAILS_GET_AFTER_LOGIN = buildHttpEndpoint('/detailsAfterLogin');
export const SAVE_PIN = buildHttpEndpoint('/savePIN');
export const SESSION_TIME = buildHttpEndpoint('/status/sessionTime');
export const GET_MESSAGES = buildHttpEndpoint('/conversation/messages/');
export const REPLY_TO_MESSAGE = buildHttpEndpoint('/conversation/reply');
export const GET_ALL_CONVERSATIONS = buildHttpEndpoint('/menu/all/');
export const SWITCH_CONVERSATION = buildHttpEndpoint('/menu/switch/');
export const ATTACHMENT_DOWNLOAD = buildHttpEndpoint('/download');

/**
 * Create an absolute HTTP API URI
 * @param {string} relativePath relative endpoint path
 * @return {string} absolute URI
 */
function buildHttpEndpoint(relativePath) {
    const servletContext = '/api';
    return servletContext + relativePath;
}